import React, { useEffect, useState } from "react";
import {
  getTeamMembers,
  getAllProperties,
  filterArrayWithQuery,
  getBankBranchByIfsc,
  getBankByUuid,
  createAuctionEvent,
  updateAuctionEvent,
  amountInWords,
  convertAmmountToWords,
} from "services";
import { Input } from "../../../shadcn/components/ui/input";
import { Dropdown } from "../../../shadcn/components/custom/Dropdown";
import { Button } from "../../../shadcn/components/ui/button";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import { DateTime } from "luxon";
import ScrollableTextArea from "./ScrollableTextArea";
import CheckIcon from "../../../icons/CheckIcon";
import { LoadingSpinner } from "../../../icons/LoadingSpinner";

export interface EventFormPorps {
  mode?: string;
  prefillData?: any;
}

export default function EventForm(props: EventFormPorps) {
  const router = useRouter();
  const [teamsDataStatic, setTeamsDataStatic] = useState<any>();
  const [propertiesDataStatic, setPropertiesDataStatic] = useState<any>();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const userProfile = useSelector((state: any) => {
    return state.bankerAuth.user;
  });

  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });

  const bank = useSelector((state: any) => {
    return state.bankerAuth.bank;
  });

  const form = useBetaForm({
    property_uuid: "",
    created_by: userProfile.uuid ? userProfile.uuid : "",
    event_name: "",
    event_type: "",
    assigned_ao: "",
    signature_type: "",
    kyc_type: "",
    auction_type: { label: "Forward", value: "Forward" },
    auction_currency: { label: "INR", value: "INR" },
    possession_type: "",
    auto_extension: { label: "Yes", value: "Yes" },
    auto_extension_type: "",
    auto_extension_limit: "",
    extension_method: "",
    extend_time_at: "",
    extend_time_by: "",
    bidding_increment_amount: "",
    borrower_name: "",
    emd_payment_account_name: "",
    emd_payment_account_number: "",
    emd_payment_account_ifsc: "",
    emd_payment_account_bank: "",
    emd_payment_account_branch: "",
    emd_payment_method: "",
    comment: "",
    approver: "",
    bidding_type: "",
    enable_offline_payment_validation: "",
  });

  const form_constraints = {
    event_name: {
      presence: {
        allowEmpty: false,
      },
    },
    approver: {
      presence: {
        allowEmpty: false,
      },
    },
    event_type: {
      presence: {
        allowEmpty: false,
      },
    },
    signature_type: {
      presence: {
        allowEmpty: false,
      },
    },
    possession_type: {
      presence: {
        allowEmpty: false,
      },
    },
    kyc_type: {
      presence: {
        allowEmpty: false,
      },
    },
    property_uuid: {
      presence: {
        allowEmpty: false,
      },
    },
    bidding_increment_amount: {
      presence: {
        allowEmpty: false,
      },
    },
    borrower_name: {
      presence: {
        allowEmpty: false,
      },
    },
    emd_payment_account_number: {
      presence: {
        allowEmpty: false,
      },
      length: {
        maximum: 25,
      },
    },

    emd_payment_account_name: {
      presence: {
        allowEmpty: false,
      },
    },
    emd_payment_account_ifsc: {
      presence: {
        allowEmpty: false,
      },
    },
    emd_payment_account_bank: {
      presence: {
        allowEmpty: false,
      },
    },
    emd_payment_account_branch: {
      presence: {
        allowEmpty: false,
      },
    },
    emd_payment_method: {
      presence: {
        allowEmpty: false,
      },
    },
    bidding_type: {
      presence: {
        allowEmpty: false,
      },
    },
    enable_offline_payment_validation: {
      presence: {
        allowEmpty: true,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  const biddingTypeValues: any = {
    rp: "With Reserve Price",
    ib: "With Increment Price",
  };

  useEffect(() => {
    if ((props.mode === "edit" || props.mode === "view") && props.prefillData) {
      prefillFormValues(props.prefillData);
    }
  }, [props.mode, props.prefillData, currentBranch]);

  const prefillFormValues = async (data: any) => {
    form.setField("event_name", data.event_name);
    form.setField("event_type", {
      label: data.event_type,
      value: data.event_type,
    });
    form.setField("signature_type", {
      label: data.signature_type,
      value: data.signature_type,
    });
    form.setField("kyc_type", {
      label: data.kyc_type,
      value: data.kyc_type,
    });
    form.setField("auction_type", {
      label: data.auction_type,
      value: data.auction_type,
    });
    form.setField("auction_currency", {
      label: data.auction_currency,
      value: data.auction_currency,
    });
    form.setField("possession_type", {
      label: data.possession_type,
      value: data.possession_type,
    });

    form.setField("auto_extension", {
      label: data.auto_extension,
      value: data.auto_extension,
    });
    form.setField("extension_method", {
      label: data.extension_method,
      value: data.extension_method,
    });
    form.setField("auto_extension_type", {
      label: data.auto_extension_type,
      value: data.auto_extension_type,
    });

    form.setField("auto_extension_limit", data.auto_extension_limit);

    form.setField("extend_time_at", data.extend_time_at);
    form.setField("extend_time_by", data.extend_time_by);

    form.setField("bidding_increment_amount", data.bidding_increment_amount);
    form.setField("borrower_name", data.borrower_name);
    form.setField("emd_payment_account_name", data.emd_payment_account_name);
    form.setField(
      "emd_payment_account_number",
      data.emd_payment_account_number,
    );
    form.setField("emd_payment_account_ifsc", data.emd_payment_account_ifsc);
    form.setField("emd_payment_account_bank", data.emd_payment_account_bank);
    form.setField(
      "emd_payment_account_branch",
      data.emd_payment_account_branch,
    );
    form.setField("emd_payment_method", {
      label: data.emd_payment_method,
      value: data.emd_payment_method,
    });

    form.setField("bidding_type", {
      label: biddingTypeValues[data.bidding_type],
      value: data.bidding_type,
    });

    form.setField("comment", data.comment);
    const propertyData: any = await getPropertiesData("");
    if (propertyData) {
      propertyData.map((item: any) => {
        if (item.value === data.property_uuid) {
          form.setField("property_uuid", item);
        }
      });
    }

    const teamsMembersData: any = await getMembersFilteredData();

    teamsMembersData.ao.map((item: any) => {
      if (item.value === data.assigned_ao) {
        form.setField("assigned_ao", item);
      }
    });

    teamsMembersData.so.map((item: any) => {
      if (item.value === data.approver) {
        form.setField("approver", item);
      }
    });
  };

  const handleSubmit = async () => {
    try {
      if (form.validate()) {
        form.startProcessing();
        if (props.mode === "edit") {
          const data: any = await updateAuctionEvent(
            form.value,
            props.prefillData,
            "accepted",
            "",
          );
          if (data) {
            setShowSuccessModal(true);
          }
          form.finishProcessing();
        } else {
          const data: any = await createAuctionEvent(form.value);
          if (data) {
            setShowSuccessModal(true);
          }
          form.finishProcessing();
        }
      }
    } catch (error: any) {
      form.finishProcessing();
      console.log("check here error", error);
      if (error?.response?.data?.errors) {
        form.setErrors(error.response.data.errors);
      }
    }
  };

  const getMembersFilteredData = async () => {
    const response: any = await getTeamMembers(
      currentBranch.team["teams*uuid"],
    );
    const data: any = response.data;
    const supervisorOfficers =
      data.length > 0 &&
      data.filter((item: any) => item["permissions"].role === "approver");

    const authorizedOfficers =
      data.length > 0 &&
      data.filter((item: any) => item["permissions"].role === "member");

    const filteredAoData = authorizedOfficers.map((item: any) => {
      return {
        value: item["user_uuid"],
        label: item["attributes"][0]?.value
          ? item["attributes"][0]?.value
          : "NA",
        profile: item?.user?.profile ?? null,
      };
    });

    const filteredSoData = supervisorOfficers.map((item: any) => {
      return {
        value: item["user_uuid"],
        label: item["user"]?.profile?.bio?.full_name
          ? item["user"]?.profile?.bio?.full_name
          : item["attributes"][0]?.value
          ? item["attributes"][0]?.value
          : "NA",
        email: item["attributes"][0]?.value
          ? item["attributes"][0]?.value
          : "NA",
        profile: item?.user?.profile ?? null,
      };
    });

    return { ao: filteredAoData, so: filteredSoData };
  };

  const getTeamsData: () => Promise<any> = async () => {
    const data = await getMembersFilteredData();
    const assignedAo = data.ao.filter(
      (item: any) => item.value === userProfile.uuid,
    );
    form.setField("assigned_ao", assignedAo[0]);

    return Promise.resolve(data.so);
  };

  const teamsData: () => Promise<any> = () => {
    return Promise.resolve(teamsDataStatic);
  };

  const propertiesData: () => Promise<any> = () => {
    return Promise.resolve(propertiesDataStatic);
  };

  const getPropertiesData = async (query: any) => {
    const data: any = await getAllProperties({
      apiConfig: {
        includeRelations: ["city", "sub_asset_type", "bank", "branch"],
        includeMutations: ["state", "asset"],
        includeFacets: false,
      },
      limitBy: {
        per_page: 999,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [
        // enable it once testing is done
        // {
        //   attribute: "status",
        //   op: "eq",
        //   value: "active",
        // },
        {
          attribute: "branch_uuid",
          op: "eq",
          value: currentBranch.value,
        },
      ],
    });

    let filteredData =
      data.data.length > 0 &&
      data.data.map((item: any) => {
        return {
          value: item.uuid,
          label: item.property_id,
          property:
            props.prefillData && props.prefillData?.status === "end"
              ? props.prefillData.property_dump
              : item,
        };
      });

    if (query && query !== "") {
      filteredData = filterArrayWithQuery(filteredData, query);
    }
    return filteredData;
  };

  const handleIFSCCode = async (value: any) => {
    form.setField("emd_payment_account_ifsc", value);
    if (value.length > 6) {
      const data: any = await getBankBranchByIfsc(value);
      if (data) {
        form.setField("emd_payment_account_branch", data.name);
        const bankData: any = await getBankByUuid(data.bank_uuid);
        if (bankData) {
          form.setField("emd_payment_account_bank", bankData.name);
        }
      } else {
        form.setField("emd_payment_account_branch", "");
        form.setField("emd_payment_account_bank", "");
      }
    }
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await getTeamsData();
        setTeamsDataStatic(response);

        const propertyResponse = await getPropertiesData("");
        setPropertiesDataStatic(propertyResponse);
      } catch (err) {
        console.log("error", err);
      }
    };

    fetch();
  }, []);

  const SuccessModal = () => {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
        <div className="bg-white shadow-2xl rounded-xl w-full max-w-lg">
          <div className="w-full flex flex-col items-center px-4 py-6 border bg-[#FCFFFB] border-brand-bgGrey rounded-lg">
            <CheckIcon className="h-7 w-7 text-brand-bgSuccessGreen" />
            <div className="flex items-center space-x-3">
              <div>
                <p className="font-openSans text-[22px] font-semibold text-brand-bgBlack">
                  {`Event ${
                    props.mode === "edit" ? "Updated" : "Created"
                  } Successfully`}
                </p>
                <p className="font-openSans text-[16px] text-gray-700 text-center">
                  {`Event has been ${
                    props.mode === "edit" ? "updated" : "created"
                  } successfully!`}
                </p>
              </div>
            </div>

            <div className="w-full mt-8">
              <Button
                className="bg-brand-bgBlack text-white px-6 py-2 rounded-lg  w-full"
                onClick={() => {
                  router.push("/dashboard/events");
                }}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="mt-[30px]">
        <p className="font-openSans font-normal text-web-subheading leading-6 text-brand-bgBlack">
          {props?.mode === "edit" ? (
            <>
              Update Event
              {props?.prefillData?.listing_id && (
                <>
                  {" ID - "}
                  <strong>{props.prefillData.listing_id}</strong>
                </>
              )}
            </>
          ) : (
            "Create Event"
          )}
        </p>
        {/* Events Details */}
        <div className="bg-brand-bgLightGrey mt-6 py-7 px-4 lg:pl-[34px] lg:pr-[71px]">
          <p className="font-openSans font-semibold text-web-body-lg leading-6 text-brand-bgBlack">
            Event details
          </p>
          <div className="flex flex-col  sm:grid  sm:grid-cols-2 mt-5 gap-y-4 lg:gap-y-7 gap-x-4">
            <div className={`relative w-full col-span-2`}>
              <ScrollableTextArea
                onChange={(e) => {
                  form.setField("event_name", e.target?.value);
                }}
                value={form.getField("event_name")}
                placeholder="Event Name"
                className={`bg-white border-[#E5E7EB] disabled:bg-[#e5e7eb] focus:ring-0 disabled:border-none peer block w-full appearance-none  pt-6 pb-0 pl-4  focus:pb-0 outline-none font-openSans font-normal text-web-body-md lg:text-web-body-lg leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />

              {form.errors.get("event_name") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("event_name")[0]}
                </p>
              )}
            </div>
            <div className="w-full relative ">
              <Dropdown
                dataSource={teamsData}
                defaultSelected={
                  form.getField("approver") !== ""
                    ? form.getField("approver")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) => form.setField("approver", value)}
                valueKey="value"
                placeholder={"Approver"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white   w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("approver")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("approver") !== ""
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Approver
              </div>
              {form.errors.get("approver") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("approver")[0]}
                </label>
              )}
            </div>

            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [
                    { label: "Sarfaesi", value: "Sarfaesi" },
                    { label: "DRT", value: "DRT" },
                    { label: "Private", value: "Private" },
                    { label: "IBC", value: "IBC" },
                    { label: "Asset transfer", value: "Asset Transfer" },
                  ];
                }}
                defaultSelected={
                  form.getField("event_type") !== ""
                    ? form.getField("event_type")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) => form.setField("event_type", value)}
                valueKey="value"
                placeholder={"Event Type"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white   w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("event_type")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("event_type")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Event Type
              </div>
              {form.errors.get("event_type") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("event_type")[0]}
                </label>
              )}
            </div>

            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [
                    { label: "DSC", value: "DSC" },
                    { label: "Aadhaar OTP", value: "Aadhaar OTP" },
                    {
                      label: "Inked Physical form to be sent to Bank",
                      value: "Inked Physical form to be sent to Bank",
                    },
                  ];
                }}
                defaultSelected={
                  form.getField("signature_type") !== ""
                    ? form.getField("signature_type")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) =>
                  form.setField("signature_type", value)
                }
                valueKey="value"
                placeholder={"Signature Type"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white   w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("signature_type")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("signature_type")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Signature Type
              </div>
              {form.errors.get("signature_type") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("signature_type")[0]}
                </label>
              )}
            </div>
            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [{ label: "Forward", value: "Forward" }];
                }}
                defaultSelected={
                  form.getField("auction_type") !== ""
                    ? form.getField("auction_type")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) => form.setField("auction_type", value)}
                valueKey="value"
                placeholder={"Auction Type"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white   w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("auction_type")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans text-[12px] leading-[13px] top-1 transition-all duration-300  left-3 ${
                  form.getField("auction_type")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Auction Type
              </div>
              {form.errors.get("auction_type") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("auction_type")[0]}
                </label>
              )}
            </div>
            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [{ label: "INR", value: "INR" }];
                }}
                defaultSelected={
                  form.getField("auction_currency") !== ""
                    ? form.getField("auction_currency")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) =>
                  form.setField("auction_currency", value)
                }
                valueKey="value"
                placeholder={"Auction Currency"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white   w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("auction_currency")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans text-[12px] leading-[13px] top-1 transition-all duration-300  left-3 ${
                  form.getField("auction_currency")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Auction Currency
              </div>
              {form.errors.get("auction_currency") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("auction_currency")[0]}
                </label>
              )}
            </div>
            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [
                    { label: "Symbolic", value: "Symbolic" },
                    { label: "Physical", value: "Physical" },
                  ];
                }}
                defaultSelected={
                  form.getField("possession_type") !== ""
                    ? form.getField("possession_type")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) =>
                  form.setField("possession_type", value)
                }
                valueKey="value"
                placeholder={"Possession Type"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px]  min-w-[130px] bg-white   w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("possession_type")
                      ? "items-end text-brand-textLightGrey "
                      : "text-brand-borderGrey "
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans text-[12px] leading-[13px] top-1 transition-all duration-300  left-3 ${
                  form.getField("possession_type") !== ""
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Possession Type
              </div>
              {form.errors.get("possession_type") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("possession_type")[0]}
                </label>
              )}
            </div>

            <div className="w-full relative col-span-2">
              <Dropdown
                dataSource={async () => {
                  return [
                    { label: "KYC by auctionbazaar.com", value: "DSC" },
                    {
                      label:
                        "Physical KYC required - To be submitted by client physically at Bank",
                      value:
                        "Physical KYC required - To be submitted by client physically at Bank",
                    },
                  ];
                }}
                defaultSelected={
                  form.getField("kyc_type") !== ""
                    ? form.getField("kyc_type")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) => form.setField("kyc_type", value)}
                valueKey="value"
                placeholder={"KYC Type"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white   w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("kyc_type")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans text-[12px] leading-[13px] top-1 transition-all duration-300  left-3 ${
                  form.getField("kyc_type")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                KYC Type
              </div>
              {form.errors.get("kyc_type") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("kyc_type")[0]}
                </label>
              )}
            </div>
          </div>
        </div>

        {/* Property Details */}
        <div className="bg-brand-bgLightGrey mt-6 py-7 px-4 lg:pl-[34px] lg:pr-[71px]">
          <p className="font-openSans font-semibold text-web-body-lg leading-6 text-brand-bgBlack">
            Property details
          </p>
          <div className="flex flex-col  sm:grid  sm:grid-cols-2 mt-5 gap-y-4 lg:gap-y-7 gap-x-4">
            <div className="w-full relative">
              <Dropdown
                dataSource={propertiesData}
                defaultSelected={
                  form.getField("property_uuid") !== ""
                    ? form.getField("property_uuid")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) => form.setField("property_uuid", value)}
                valueKey="value"
                placeholder={"Property Id"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white   w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("property_uuid")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("property_uuid")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Property Id
              </div>
              {form.errors.get("property_uuid") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("property_uuid")[0]}
                </label>
              )}
            </div>

            <div className={`relative w-full`}>
              <Input
                id="name"
                disabled={true}
                value={form.value.property_uuid.property?.state.name}
                onChange={(e) =>
                  form.setField("property_state", e.target.value)
                }
                className={`bg-white capitalize peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Property State
              </label>
              {form.errors.get("property_state") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("property_state")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full col-span-2`}>
              <textarea
                id="name"
                disabled={true}
                rows={6}
                value={form.value.property_uuid.property?.address}
                onChange={(e) =>
                  form.setField("property_address", e.target.value)
                }
                className={`bg-white disabled:bg-[#e5e7eb] disabled:border-none peer block w-full appearance-none border pt-6 pb-0 pl-4  focus:pb-0 outline-none font-openSans font-normal text-web-body-lg leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300  text-gray-400 top-[6px] text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Property Address
              </label>
              {form.errors.get("property_address") && (
                <p className="text-brand-textRed absolute mt-1 text-web-body-sm ml-2">
                  {form.errors.get("property_address")[0]}
                </p>
              )}
            </div>
            {/* Price Section */}
            <div className={`relative w-full`}>
              <Input
                id="name"
                disabled={true}
                value={form.value.property_uuid.property?.reserve_price}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Reserve Price
              </label>
              {form.errors.get("reserve_price") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("reserve_price")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full`}>
              <Input
                id="name"
                disabled={true}
                value={form.value.property_uuid.property?.emd_amount}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                EMD Price
              </label>
              {form.errors.get("emd_amount") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("emd_amount")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full`}>
              <textarea
                id="name"
                disabled={true}
                rows={2}
                value={convertAmmountToWords(
                  form.value.property_uuid.property?.reserve_price,
                )}
                onChange={(e) =>
                  form.setField("property_address", e.target.value)
                }
                className={`bg-white disabled:bg-[#e5e7eb] disabled:border-none peer block w-full appearance-none border pt-6 pb-0 pl-4  focus:pb-0 outline-none font-openSans font-normal text-web-body-lg leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300  text-gray-400 top-[6px] text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Reserve Price In Words
              </label>
              {form.errors.get("property_address") && (
                <p className="text-brand-textRed absolute mt-1 text-web-body-sm ml-2">
                  {form.errors.get("property_address")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full`}>
              <textarea
                id="name"
                disabled={true}
                rows={2}
                value={convertAmmountToWords(
                  form.value.property_uuid.property?.emd_amount,
                )}
                className={`bg-white disabled:bg-[#e5e7eb] disabled:border-none peer block w-full appearance-none border pt-6 pb-0 pl-4  focus:pb-0 outline-none font-openSans font-normal text-web-body-lg leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300  text-gray-400 top-[6px] text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                EMD Price In Words
              </label>
              {form.errors.get("property_address") && (
                <p className="text-brand-textRed absolute mt-1 text-web-body-sm ml-2">
                  {form.errors.get("property_address")[0]}
                </p>
              )}
            </div>
            {/* Date time */}
            <div className={`relative w-full col-span-2`}>
              <Input
                id="name"
                disabled={true}
                value={DateTime.fromISO(
                  form.value.property_uuid.property?.emd_last_date,
                )
                  .setZone("Asia/Kolkata")
                  .toFormat("MMM dd, yyyy, hh:mm a")}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                EMD Last Date and Time (IST)
              </label>
              {form.errors.get("emd_last_date") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("emd_last_date")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full `}>
              <Input
                id="name"
                disabled={true}
                value={DateTime.fromISO(
                  form.value.property_uuid.property?.auction_start_date_time,
                )
                  .setZone("Asia/Kolkata")
                  .toFormat("MMM dd, yyyy, hh:mm a")}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Auction Start Date and Time (IST)
              </label>
              {form.errors.get("auction_start_date_time") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("auction_start_date_time")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full `}>
              <Input
                id="name"
                disabled={true}
                value={DateTime.fromISO(
                  form.value.property_uuid.property?.auction_end_date_time,
                )
                  .setZone("Asia/Kolkata")
                  .toFormat("MMM dd, yyyy, hh:mm a")}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Auction End Date and Time (IST)
              </label>
              {form.errors.get("auction_end_date_time") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("auction_end_date_time")[0]}
                </p>
              )}
            </div>
            {/* Drop down */}

            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                  ];
                }}
                defaultSelected={
                  form.getField("auto_extension") !== ""
                    ? form.getField("auto_extension")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) =>
                  form.setField("auto_extension", value)
                }
                valueKey="value"
                placeholder={"Auto Extension"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white    w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("auto_extension")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("auto_extension")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Auto Extension
              </div>
              {form.errors.get("auto_extension") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("auto_extension")[0]}
                </label>
              )}
            </div>
            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [
                    { label: "Unlimited", value: "Unlimited" },
                    { label: "Limited", value: "Limited" },
                  ];
                }}
                defaultSelected={
                  form.getField("auto_extension_type") !== ""
                    ? form.getField("auto_extension_type")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) =>
                  form.setField("auto_extension_type", value)
                }
                valueKey="value"
                placeholder={"Auto Extension Type"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white    w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("auto_extension_type")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("auto_extension_type")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Auto Extension Type
              </div>
              {form.errors.get("auto_extension_type") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("auto_extension_type")[0]}
                </label>
              )}
            </div>
            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [
                    { label: "With Current Time", value: "with_current_time" },
                    { label: "With Final Time", value: "with_final_time" },
                  ];
                }}
                defaultSelected={
                  form.getField("extension_method") !== ""
                    ? form.getField("extension_method")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) =>
                  form.setField("extension_method", value)
                }
                valueKey="value"
                placeholder={"Extension Method"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white    w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("extension_method")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("extension_method")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Extension Method
              </div>
              {form.errors.get("extension_method") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("extension_method")[0]}
                </label>
              )}
            </div>
            {form.value.auto_extension_type.value === "Limited" && (
              <div className={`relative w-full`}>
                <Input
                  type="number"
                  id="name"
                  min={0}
                  value={form.getField("auto_extension_limit")}
                  onWheel={(e: any) => e.target.blur()}
                  onChange={(e) => {
                    form.setField("auto_extension_limit", e.target.value);
                  }}
                  className={`bg-white   py-4 peer pl-4 autofill:bg-white focus:border-brand-orange focus:outline-none focus:ring-0 pb-[6px] h-[50px]   outline-none  border border-[#EEEEEE]  w-full   font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey `}
                />
                <label
                  htmlFor="name"
                  className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
                >
                  Auto Extension Limited by (Minutes)
                </label>
                {form.errors.get("auto_extension_limit") && (
                  <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                    {form.errors.get("auto_extension_limit")[0]}
                  </p>
                )}
              </div>
            )}

            <div className="w-full relative ">
              <Input
                type="number"
                id="name"
                min={0}
                value={form.getField("extend_time_at")}
                onWheel={(e: any) => e.target.blur()}
                onChange={(e) => {
                  form.setField("extend_time_at", e.target.value);
                }}
                className={`bg-white   py-4 peer pl-4 autofill:bg-white focus:border-brand-orange focus:outline-none focus:ring-0 pb-[6px] h-[50px]   outline-none  border border-[#EEEEEE]  w-full   font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey `}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Extend time when valid bids received in last
              </label>
              {form.errors.get("extend_time_at") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("extend_time_at")[0]}
                </p>
              )}
            </div>
            <div className="w-full relative ">
              <Input
                type="number"
                id="name"
                min={0}
                value={form.getField("extend_time_by")}
                onWheel={(e: any) => e.target.blur()}
                onChange={(e) => {
                  form.setField("extend_time_by", e.target.value);
                }}
                className={`bg-white   py-4 peer pl-4 autofill:bg-white focus:border-brand-orange focus:outline-none focus:ring-0 pb-[6px] h-[50px]   outline-none  border border-[#EEEEEE]  w-full   font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey `}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Extend Time By
              </label>
              {form.errors.get("extend_time_by") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("extend_time_by")[0]}
                </p>
              )}
            </div>

            <div className={`relative w-full`}>
              <Input
                type="number"
                id="name"
                min={0}
                value={form.getField("bidding_increment_amount")}
                onWheel={(e: any) => e.target.blur()}
                onChange={(e) => {
                  form.setField("bidding_increment_amount", e.target.value);
                }}
                className={`bg-white   py-4 peer pl-4 autofill:bg-white focus:border-brand-orange focus:outline-none focus:ring-0 pb-[6px] h-[50px]   outline-none  border border-[#EEEEEE]  w-full   font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey `}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Bidding Increment in Multiple of
              </label>
              {form.errors.get("bidding_increment_amount") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("bidding_increment_amount")[0]}
                </p>
              )}
            </div>

            <div className={`relative w-full col-span-2`}>
              <textarea
                id="name"
                disabled={true}
                rows={2}
                value={amountInWords(form.value.bidding_increment_amount)}
                onChange={(e) =>
                  form.setField("bidding_increment_amount_word", e.target.value)
                }
                className={`bg-white disabled:bg-[#e5e7eb] disabled:border-none peer block w-full appearance-none border pt-6 pb-0 pl-4  focus:pb-0 outline-none font-openSans font-normal text-web-body-lg leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300  text-gray-400 top-[6px] text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Bidding Increment in Multiple of (in Words)
              </label>
              {form.errors.get("bidding_increment_amount_word") && (
                <p className="text-brand-textRed absolute mt-1 text-web-body-sm ml-2">
                  {form.errors.get("bidding_increment_amount_word")[0]}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Other Details */}
        <div className="bg-brand-bgLightGrey mt-6 py-7 px-4 lg:pl-[34px] lg:pr-[71px]">
          <p className="font-openSans font-semibold text-web-body-lg leading-6 text-brand-bgBlack">
            Other details
          </p>
          <div className="sm: grid sm:grid-cols-2 mt-5 gap-y-4 lg:gap-y-7 gap-x-4">
            <div className={`relative w-full col-span-2`}>
              <Input
                id="name"
                onChange={(e) => {
                  form.setField("borrower_name", e.target.value);
                }}
                value={form.getField("borrower_name")}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Borrower Name
              </label>
              {form.errors.get("borrower_name") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("borrower_name")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full col-span-2`}>
              <Input
                id="name"
                disabled={true}
                value={
                  form.value.property_uuid.property
                    ?.physical_inspection_timeline
                }
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Inspection of asset to Date and Time
              </label>
            </div>

            <div className={`relative w-full col-span-2`}>
              <Input
                id="name"
                disabled={true}
                value={form.value.property_uuid.property?.contact}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Inspection Officer Contact Details
              </label>
            </div>
            <div className={`relative w-full col-span-2`}>
              <textarea
                id="name"
                rows={3}
                onChange={(e) => {
                  form.setField("comment", e.target.value);
                }}
                value={form.getField("comment")}
                className={`bg-white border-[#E5E7EB] disabled:bg-[#e5e7eb] focus:ring-0 disabled:border-none peer block w-full appearance-none  pt-6 pb-0 pl-4  focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300  text-gray-400 top-[6px] text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Remarks
              </label>
              {form.errors.get("comment") && (
                <p className="text-brand-textRed absolute mt-1 text-web-body-sm ml-2">
                  {form.errors.get("comment")[0]}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* EMD Payment Account Details */}
        <div className="bg-brand-bgLightGrey mt-6 py-7 px-4 lg:pl-[34px] lg:pr-[71px]">
          <p className="font-openSans font-semibold text-web-body-lg leading-6 text-brand-bgBlack">
            EMD Payment Account Details
          </p>
          <div className="sm: grid sm:grid-cols-2 mt-5 gap-y-4 lg:gap-y-7 gap-x-4">
            <div className={`relative w-full`}>
              <Input
                id="name"
                onChange={(e) => {
                  form.setField("emd_payment_account_name", e.target.value);
                }}
                value={form.getField("emd_payment_account_name")}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Account Name
              </label>
              {form.errors.get("emd_payment_account_name") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("emd_payment_account_name")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full`}>
              <Input
                id="name"
                onChange={(e) => {
                  form.setField("emd_payment_account_number", e.target.value);
                }}
                value={form.getField("emd_payment_account_number")}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Account Number
              </label>
              {form.errors.get("emd_payment_account_number") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("emd_payment_account_number")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full`}>
              <Input
                id="name"
                onChange={(e) => handleIFSCCode(e.target.value)}
                value={form.getField("emd_payment_account_ifsc")}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                IFSC Code
              </label>
              {form.errors.get("emd_payment_account_ifsc") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("emd_payment_account_ifsc")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full`}>
              <Input
                id="name"
                onChange={(e) => {
                  form.setField("emd_payment_account_bank", e.target.value);
                }}
                value={form.getField("emd_payment_account_bank")}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Bank Name
              </label>
              {form.errors.get("emd_payment_account_bank") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("emd_payment_account_bank")[0]}
                </p>
              )}
            </div>
            <div className={`relative w-full`}>
              <Input
                id="name"
                onChange={(e) => {
                  form.setField("emd_payment_account_branch", e.target.value);
                }}
                value={form.getField("emd_payment_account_branch")}
                className={`bg-white peer block w-full appearance-none border pt-3 pb-0 pl-4 h-[50px] focus:pb-0 outline-none font-openSans font-normal text-web-body-md leading-4 text-brand-textLightGrey focus:border-brand-orange`}
              />
              <label
                htmlFor="name"
                className={`absolute font-openSans font-normal  left-4 transition-all duration-300 -translate-y-1/2  text-gray-400 top-1/4 text-[12px] leading-[13px] peer-focus:text-brand-orange`}
              >
                Branch Name
              </label>
              {form.errors.get("emd_payment_account_branch") && (
                <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
                  {form.errors.get("emd_payment_account_branch")[0]}
                </p>
              )}
            </div>

            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [
                    {
                      label: "Online - NEFT/RTGS",
                      value: "Online - NEFT/RTGS",
                    },
                    {
                      label: "Offline payment at Bank",
                      value: "Offline payment at Bank",
                    },
                  ];
                }}
                defaultSelected={
                  form.getField("emd_payment_method") !== ""
                    ? form.getField("emd_payment_method")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) =>
                  form.setField("emd_payment_method", value)
                }
                valueKey="value"
                placeholder={"EMD Payment Method"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white    w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("emd_payment_method")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("emd_payment_method")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                EMD Payment Method
              </div>
              {form.errors.get("emd_payment_method") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("emd_payment_method")[0]}
                </label>
              )}
            </div>

            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [
                    { label: "With Reserve Price", value: "rp" },
                    {
                      label: "With Increment Price",
                      value: "ib",
                    },
                  ];
                }}
                defaultSelected={
                  form.getField("bidding_type") !== ""
                    ? form.getField("bidding_type")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) => form.setField("bidding_type", value)}
                valueKey="value"
                placeholder={"Bidding Type"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white    w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("bidding_type")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("bidding_type")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Bidding Type
              </div>
              {form.errors.get("bidding_type") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("bidding_type")[0]}
                </label>
              )}
            </div>
            <div className="w-full relative ">
              <Dropdown
                dataSource={async () => {
                  return [
                    { label: "Approval required", value: "true" },
                    { label: "No approval", value: "false" },
                  ];
                }}
                defaultSelected={
                  form.getField("enable_offline_payment_validation") !== ""
                    ? form.getField("enable_offline_payment_validation")
                    : []
                }
                selectIdentifier={true}
                onChange={(value: any) =>
                  form.setField("enable_offline_payment_validation", value)
                }
                valueKey="value"
                placeholder={"Enable Payment Validation"}
                styles={{
                  dropdownItemsClass: "bg-white text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightOrange",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  hideDot: true,
                  outerContainer: `border-[1px] min-w-[130px] bg-white    w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
                    form.getField("enable_offline_payment_validation")
                      ? "items-end text-brand-textLightGrey"
                      : "text-brand-borderGrey"
                  } leading-5 `,
                }}
              />

              <div
                className={`absolute font-openSans top-1 text-[10px] transition-all duration-300  left-3 ${
                  form.getField("enable_offline_payment_validation")
                    ? "text-brand-borderGrey"
                    : "text-transparent"
                }`}
              >
                Enable Payment Validation
              </div>
              {form.errors.get("enable_offline_payment_validation") && (
                <label
                  htmlFor="name"
                  className={"text-brand-textRed text-web-body-sm ml-2"}
                >
                  {form.errors.get("enable_offline_payment_validation")[0]}
                </label>
              )}
            </div>
          </div>
        </div>

        {props.mode !== "view" &&
          (!props.prefillData ||
            ["pending", "accepted", "rejected"].includes(
              props.prefillData?.status,
            )) && (
            <div className="text-center flex justify-end sm:text-left pt-2 col-span-2">
              <Button
                className="bg-brand-textLightGrey py-3 px-5 w-[240px] lg:translate-x-[55px] mt-[42px]"
                onClick={() => handleSubmit()}
                disabled={form.busy}
              >
                {form.busy ? <LoadingSpinner /> : "Save & Submit "}
              </Button>
            </div>
          )}
      </div>
      {showSuccessModal && <SuccessModal />}
    </>
  );
}
